import * as RCheckbox from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from './cn';

export interface CheckboxProps {
  checked?: boolean | 'indeterminate';
  onCheckedChange?: (checked: boolean) => void;
  label?: ReactNode;
  disabled?: boolean;
  className?: string;
  'aria-label'?: string;
}

/** Checkbox (replaces antd Checkbox) built on Radix Checkbox. */
export function Checkbox({ checked, onCheckedChange, label, disabled, className, ...rest }: CheckboxProps) {
  return (
    <label className={cn('inline-flex cursor-pointer items-center gap-2 text-sm text-content', disabled && 'cursor-not-allowed opacity-50', className)}>
      <RCheckbox.Root
        checked={checked}
        onCheckedChange={(c) => onCheckedChange?.(c === true)}
        disabled={disabled}
        aria-label={rest['aria-label']}
        className="grid size-[18px] shrink-0 place-items-center rounded-[5px] border border-line bg-surface transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/40 data-[state=checked]:border-brand-600 data-[state=checked]:bg-brand-600 data-[state=indeterminate]:border-brand-600 data-[state=indeterminate]:bg-brand-600"
      >
        <RCheckbox.Indicator>
          {checked === 'indeterminate' ? <Minus size={13} className="text-white" /> : <Check size={13} className="text-white" />}
        </RCheckbox.Indicator>
      </RCheckbox.Root>
      {label != null && <span>{label}</span>}
    </label>
  );
}
